import classNames from 'classnames';
import React from 'react';
import { COMMENT_FOOTER_ERROR_EDIT, COMMENT_FOOTER_ERROR_RETRY, } from '../../../../common/constants/data-hooks';
import { ExclamationIcon } from '../../icons/exclamation-icon';
import TextExtended from '../../text-extended/text-extended';
import styles from './comment-error-footer.scss';
import { TooltipLazy } from '../../tooltip-lazy/tooltip-lazy';
import { useTranslate } from '../../../context/api-context/translations/use-translate';
import { unreachable } from '../../../../ts-utils';
const CommentErrorFooter = ({ onRetry, onEdit, error: optionalError }) => {
    const error = optionalError ?? { type: 'SILENT' };
    const t = useTranslate();
    const getTooltipMessage = () => {
        switch (error.type) {
            case 'SILENT':
                return t('comment-footer.unable-to-publish');
            case 'TOAST': {
                const message = error.message;
                switch (message.type) {
                    case 'TRANSLATION':
                        return t(message.key, message.keyValue);
                    case 'EXTERNAL_TRANSLATION':
                        return t(message.key, message.keyValue);
                    case 'CUSTOM':
                        return message.content;
                    default:
                        throw unreachable(message);
                }
            }
            case 'MODAL':
                return t('comment-footer.comment-blocked');
            default:
                throw unreachable(error);
        }
    };
    const tooltipMessage = getTooltipMessage();
    return (React.createElement("div", { className: styles.container },
        React.createElement(TooltipLazy, { minWidth: 170, appendTo: "window", content: React.createElement("div", { className: styles.tooltip }, tooltipMessage), disabled: !tooltipMessage },
            React.createElement("div", { className: styles.tooltipInner },
                React.createElement(ExclamationIcon, { className: styles.icon }),
                React.createElement(TextExtended, { className: styles.tooltipText, priority: "secondary", typography: "contentSmall" }, t('comment-footer.unable-to-publish')))),
        React.createElement(TextExtended, { priority: "secondary", typography: "contentSmall" },
            React.createElement("button", { "data-hook": COMMENT_FOOTER_ERROR_RETRY, className: classNames('wc-button-secondary-text-color', styles.button), onClick: onRetry },
                React.createElement(TextExtended, { priority: "buttonSecondary", typography: "contentSmall" }, t('comment-footer.retry'))),
            ` ${t('comment-footer.or')} `,
            React.createElement("button", { "data-hook": COMMENT_FOOTER_ERROR_EDIT, className: classNames('wc-link-button-color', styles.button), onClick: onEdit },
                React.createElement(TextExtended, { priority: "buttonSecondary", typography: "contentSmall" }, t('comment-footer.edit'))))));
};
export default CommentErrorFooter;
//# sourceMappingURL=comment-error-footer.js.map